var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "network_row",
    attrs: {
      "active": _vm.isSelected,
      "href": "?network=".concat(_vm.networkName)
    },
    on: {
      "click": _vm.updateNetwork
    }
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.network.name) + " " + _vm._s(_vm.network.isTestnet ? '(Testnet)' : ''))]), _c('p', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.endpoint))])]), _c('img', {
    attrs: {
      "src": "",
      "alt": "network status"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }